__turbopack_context__.v({
  "actions": "providerPageHeader-module-scss-module__cz0_Qa__actions",
  "providerPageHeader": "providerPageHeader-module-scss-module__cz0_Qa__providerPageHeader",
  "subtitle": "providerPageHeader-module-scss-module__cz0_Qa__subtitle",
  "textContent": "providerPageHeader-module-scss-module__cz0_Qa__textContent",
  "title": "providerPageHeader-module-scss-module__cz0_Qa__title",
});
